/**
 * Get the country code of the user from the request headers
 * @param request
 * @returns {undefined| countryCode}
 */
export const getUserCountryCode = (request) => {
    const { headers } = request;
    try {
        if (headers['edge-agent-geolocation-info']) {
            const geoInfo = JSON.parse(headers['edge-agent-geolocation-info']);
            return geoInfo?.countryCode;
        }
    } catch (e) {
        // eslint-disable-next-line no-console
        console.warn({
            category: 'getCountryCode',
            event: 'Encountered error retrieving edge-agent-geolocation-info header',
            operation: 'getCountryCode'
        });
    }
    return undefined;
};

/**
 * Check if the country belongs to the Google Maps exclusion list
 * @param countryCode
 * @returns {boolean}
 */
export const isCountryInGoogleMapsExclusionList = (countryCode) => {
    // List of countries that are excluded from using Google Maps
    const googleMapsExclusionList = ['CN'];
    return googleMapsExclusionList.includes(countryCode);
};

export default {
    getUserCountryCode,
    isCountryInGoogleMapsExclusionList
};
